export default "__VITE_ASSET__08181573__"